/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import MobileBackNavHeader from 'bundles/composable-page-header/components/mobile-menu-items/MobileBackNavHeader';
import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToParentPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import useEnterpriseNavButtons from 'bundles/composable-page-header/hooks/useEnterpriseNavButtons';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  subjects: css`
    padding: var(--cds-spacing-300) 0 var(--cds-spacing-100) 0;
  `,
};

export const ExploreEnterpriseSubmenu = () => {
  const toParentPage = useMobileToParentPage();
  const navButtons = useEnterpriseNavButtons();

  return (
    <div>
      <MobileBackNavHeader
        label={_t('Main Menu')}
        trackingName="mobile_header_back_to_main_menu_button"
        ariaLabel={_t('Go to main navigation slide')}
        onClick={() => toParentPage?.(MOBILE_MAIN_IDENTIFIER.MAIN_MENU)}
      />
      <Typography2 variant="subtitleMedium" component="h3" css={styles.subjects}>
        {_t('Subjects')}
      </Typography2>
      {navButtons.map((btn) => (
        <MobileButton key={btn.name} {...btn} />
      ))}
    </div>
  );
};

export default ExploreEnterpriseSubmenu;
